'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.demand_control_index', {
    url: 'demand_control_index',
    template: '<demand-control-index></demand-control-index>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/demand_control/index/demand_control_index.routes.js